export default __webpack_public_path__ + "static/gitlab-432f013a112b6c09d9ad26b15539479d.png";